import issues from './issues'
import requests from './requests'

export default [
    ...issues,
    ...requests,
]